import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: './page-not-found.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundPage {
}
